var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.isImgTag)?_c('img',{attrs:{"src":_vm.src,"alt":_vm.alt}}):_c('div',{staticClass:"bg-img",style:(_vm.imgStyle)})}
var staticRenderFns = []

export { render, staticRenderFns }


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/loaders/templateLoader.js?{}!./~/vue-loader/lib?{}!./src/render/index.vue?vue&type=template&id=7c5efb2c&scoped=true&
// module id = 23
// module chunks = 1